import(/* webpackMode: "eager" */ "/home/pi/prod/strawman/apps/web/app/(landing)/resources/style.css");
;
import(/* webpackMode: "eager", webpackExports: ["FinalCTA"] */ "/home/pi/prod/strawman/apps/web/components/final-cta/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ArrowIcon","PostsList"] */ "/home/pi/prod/strawman/apps/web/components/ResourceDetails/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TallyEventsInterestButton"] */ "/home/pi/prod/strawman/apps/web/components/TallyEmbed/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/pi/prod/strawman/apps/web/styles/home.css");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/pi/prod/strawman/node_modules/.pnpm/next@15.4.4_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/app-dir/link.js");
